import script from "./PoolTransactionsCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoolTransactionsCard.vue?vue&type=script&setup=true&lang=ts"

import "./PoolTransactionsCard.vue?vue&type=style&index=0&id=07916a2e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07916a2e"]])

export default __exports__